function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SiteData = /*#__PURE__*/function () {
  function SiteData() {
    _classCallCheck(this, SiteData);
  }

  _createClass(SiteData, null, [{
    key: "events",
    get: function get() {
      return _typeof(this.read('events')) === 'object' ? this.read('events') : {};
    }
  }, {
    key: "config",
    get: function get() {
      return _typeof(this.read('config')) === 'object' ? this.read('config') : {};
    }
  }, {
    key: "read",
    value: function read(key) {
      if (typeof this.__value === 'undefined') {
        var base64 = document.querySelector('meta[name="site-data"]').getAttribute('content');
        var json = new Buffer(base64, 'base64');
        this.__value = JSON.parse(json);
      }

      return this.__value[key];
    }
  }]);

  return SiteData;
}();

export default SiteData;